export const LegacyEditableTypes = {
    BackgroundImage: "backgroundImage",
    Iframe: "iframe",
    Subtitles: "subtitles",
    Url: "url",
};

export const EditableType = {
    Array: "array",
    Boolean: "boolean",
    Css: "css",
    File: "file",
    Folder: "folder",
    Image: "image",
    Text: "text",
    Textarea: "textarea",
    Video: "video",
} as const;

export const EditableImageTypes = [
    EditableType.Image,
    // LegacyEditableTypes.BackgroundImage,
] as const;

export const EditableFileTypes = [
    EditableType.File,
    EditableType.Video,
    ...EditableImageTypes,
] as const;

export const EditableMediaTypes = [EditableType.Folder, ...EditableFileTypes] as const;
